import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const HoldIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 52 52"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<g filter="url(#filter0_dd_1817_68105)">
			<path
				d="M6 22C6 10.9543 14.9543 2 26 2C37.0457 2 46 10.9543 46 22C46 33.0457 37.0457 42 26 42C14.9543 42 6 33.0457 6 22Z"
				fill="#EB9421"
			/>
			<path
				d="M22.5 17.5V26.5H24V17.5H22.5ZM21 17.5C21 16.6875 21.6562 16 22.5 16H24C24.8125 16 25.5 16.6875 25.5 17.5V26.5C25.5 27.3438 24.8125 28 24 28H22.5C21.6562 28 21 27.3438 21 26.5V17.5ZM28 17.5V26.5H29.5V17.5H28ZM26.5 17.5C26.5 16.6875 27.1562 16 28 16H29.5C30.3125 16 31 16.6875 31 17.5V26.5C31 27.3438 30.3125 28 29.5 28H28C27.1562 28 26.5 27.3438 26.5 26.5V17.5Z"
				fill="white"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_1817_68105"
				x="0"
				y="0"
				width="52"
				height="52"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1817_68105" />
				<feOffset dy="2" />
				<feGaussianBlur stdDeviation="2" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1817_68105" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1817_68105" />
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_1817_68105" result="effect2_dropShadow_1817_68105" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1817_68105" result="shape" />
			</filter>
		</defs>
	</IconBase>
);
